import { FormFields } from ".";

export const PERSONAL_DETAILS: FormFields = {
  fields: [
    {
      name: "firstName",
      label: "First Name",
      type: "text",
      defaultValue: "",
      validationRules: {
        required: true,
        pattern: {
          value: /^[a-zA-Z]+$/,
          message: "First name must contain only letters",
        },
        minLength: {
          value: 2, 
          message: "First name must be at least 2 characters"
        },
        maxLength: {
          value: 50, 
          message: "First name must be at most 50 characters"
        },
      },
    },
    {
      name: "middleName",
      label: "Middle Name",
      type: "text",
      defaultValue: "",
      validationRules: {
        required: false,
        pattern: {
          value: /^[a-zA-Z]*$/, // Middle name can be empty or contain only letters
          message: "Middle name must contain only letters",
        },
        maxLength: {value: 50, message: "Middle name must be at most 50 characters"}
      },
    },
    {
      name: "lastName",
      label: "Last Name",
      type: "text",
      defaultValue: "",
      validationRules: {
        required: true,
        pattern: {
          value: /^[a-zA-Z]+$/,
          message: "Last name must contain only letters",
        },
        maxLength: {value: 50, message: "Last name must be at most 50 characters"},
        errorMessage: "Last name must not be empty and must be at most 50 characters",
      },
    },
    {
      name: "fatherName",
      label: "Father's Name",
      type: "text",
      defaultValue: "",
      validationRules: {
        required: false,
        pattern: {
          value: /^[a-zA-Z\s]*$/, // Allow letters and spaces
          message: "Father's name must contain only letters and spaces",
        },
        maxLength: {
          value: 50,
          message: "Father's name must be at most 50 characters",
        },
      },
    },
    {
      name: "motherName",
      label: "Mother's Name",
      type: "text",
      defaultValue: "",
      validationRules: {
        required: false,
        pattern: {
          value: /^[a-zA-Z\s]*$/, // Allow letters and spaces
          message: "Mother's name must contain only letters and spaces",
        },
        maxLength: {
          value: 50,
          message: "Mother's name must be at most 50 characters",
        },
      }
    },
    {
      name: "spouseName",
      label: "Spouse's Name",
      type: "text",
      defaultValue: "",
      validationRules: {
        required: false,
        pattern: {
          value: /^[a-zA-Z\s]*$/, // Allow letters and spaces
          message: "Spouse's name must contain only letters and spaces",
        },
        maxLength: {
          value: 50,
          message: "Spouse's name must be at most 50 characters",
        },
      },
    },
    {
      name: "phoneNumber",
      label: "Mobile No.",
      type: "tel",
      defaultValue: "",
      validationRules: {
        required: false,
      },
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      defaultValue: "",
      validationRules: {
        required: false,
      },
    },
    {
      name: "maritalStatus",
      label: " Marital status",
      type: "select",
      options: ["Unmarried", "Married", "Divorced", "Widowed"],
      validationRules: {
        required: false,
      },
    },

    // { name: "dateOfBirth", label: "Date of Birth", type: "date" },
    // {
    //   name: "education",
    //   label: "Education",
    //   type: "select",
    //   options: ["Below 10th", "Upto 12th", "Graduate"],
    // },
    // {
    //   name: "category",
    //   label: "Category",
    //   type: "select",
    //   options: ["SC", "ST", "OBC", "Others"],
    // },
    // { name: "religion", label: "Religion", type: "text" },
    // { name: "nationality", label: "Nationality", type: "text" },
    // { name: "panNumber", label: "PAN No.", type: "text" },
    // { name: "aadharNumber", label: "Aadhar No.", type: "text" },
    // { name: "voterId", label: "Voter ID", type: "text" },
    // { name: "drivingLicense", label: "Driving License No.", type: "text" },
    // { name: "passportNumber", label: "Passport No.", type: "text" },
    // { name: "upiId", label: "UPI ID/VPA", type: "text" },
  ],
};
